<template>
	<div id="daumContent" role="main">
		<my-cafe></my-cafe>
		<home-main></home-main>
	</div>
</template>

<script>
	import MyCafe from './components/home/MyCafe.vue'
	import HomeMain from './components/home/HomeMain.vue'

	export default {
		components: {
			MyCafe,
			HomeMain,
		},

		created() {
			this.$trackPage();
		},
	}
</script>
